import { Box, Grid, Button, Stack } from '@mui/material';
import { useRef, useState } from 'react';
import SidebarLayout from '../components/sidebarLayout';
import MappaTavoli from './MappaTavoli';
import OrdiniTempoReale from '../components/OrdiniTempoReale';

const Home = () => {
  const [mobilePanel, setMobilePanel] = useState(0);
  const [selectedTableId, setSelectedTableId] = useState(null);
  const mobileScrollerRef = useRef(null);

  const handleTableFilter = (table) => {
    const tableId = Number(table?.id);
    setSelectedTableId((current) => Number(current) === tableId ? null : tableId);
  };

  const scrollToMobilePanel = (index) => {
    setMobilePanel(index);
    const scroller = mobileScrollerRef.current;
    if (!scroller) return;
    const panel = scroller.children[index];
    if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  };

  const handleMobileScroll = () => {
    const scroller = mobileScrollerRef.current;
    if (!scroller) return;
    const next = Math.round(scroller.scrollLeft / Math.max(1, scroller.clientWidth));
    if (next !== mobilePanel) setMobilePanel(next);
  };

  return (
    <SidebarLayout>
      <Box sx={{ px: { xs: 1, sm: 2, md: '3vh' }, py: { xs: 1, md: '3vh' } }}>
        <Box sx={{ display: { xs: 'block', md: 'none' }, mb: 1 }}>
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant={mobilePanel === 0 ? 'contained' : 'outlined'}
              onClick={() => scrollToMobilePanel(0)}
              sx={{ flex: 1 }}
            >
              Tavoli
            </Button>
            <Button
              size="small"
              variant={mobilePanel === 1 ? 'contained' : 'outlined'}
              onClick={() => scrollToMobilePanel(1)}
              sx={{ flex: 1 }}
            >
              Ordini live
            </Button>
          </Stack>
        </Box>

        <Box
          ref={mobileScrollerRef}
          onScroll={handleMobileScroll}
          sx={{
            display: { xs: 'flex', md: 'none' },
            gap: 1,
            overflowX: 'auto',
            scrollSnapType: 'x mandatory',
            scrollBehavior: 'smooth',
            WebkitOverflowScrolling: 'touch',
            pb: 1,
            mx: -1,
            px: 1,
            '&::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
          }}
        >
          <Box sx={{ flex: '0 0 100%', minWidth: 0, scrollSnapAlign: 'start' }}>
            <MappaTavoli compact readOnly selectedTableId={selectedTableId} onTableSelect={handleTableFilter} />
          </Box>
          <Box sx={{ flex: '0 0 100%', minWidth: 0, scrollSnapAlign: 'start' }}>
            <OrdiniTempoReale selectedTableId={selectedTableId} />
          </Box>
        </Box>

        <Grid container spacing={{ xs: 1.5, md: 3 }} sx={{ display: { xs: 'none', md: 'flex' } }}>

          <Grid item xs={12} md={6}>
            <Box
            sx={{ display: 'flex', flexDirection: 'column', height: { xs: 'auto', md: '100%' } }}
              // sx={{
              //   border: '1px solid #CCC',
              //   borderRadius: '8px',
              //   padding: '1.719vw',
              //   // height: '633px',
              //   height: '100%',
              //   backgroundColor: theme.palette.background.paper,
              //   display: 'flex',
              //   flexDirection: 'column',
              // }}
            >
              <MappaTavoli compact readOnly selectedTableId={selectedTableId} onTableSelect={handleTableFilter} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: { xs: 'auto', md: '100%' } }}>
              <OrdiniTempoReale selectedTableId={selectedTableId} />
              {/* <AzioniRapide /> */}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </SidebarLayout>
  );
};

export default Home;
